import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('MachineFilter')
export class MachineFilter extends Entity {
  @JsonProperty('state', [String])
  public state?: [string] = undefined;
  @JsonProperty('serialNumber', [String])
  public serialNumber?: [string] = undefined;
  @JsonProperty('accountName', [String])
  public accountName?: [string] = undefined;
  @JsonProperty('location', [String])
  public location?: [string] = undefined;
  @JsonProperty('typology', [String])
  public typology?: [string] = undefined;
  @JsonProperty('orderBy', [String])
  public orderBy?: [string] = undefined;
  @JsonProperty('direction', [String])
  public direction?: [string] = undefined;
}
